import { createFileRoute, redirect } from '@tanstack/react-router';

type LegacyPublishedTimelineBeforeLoadArgs = {
  params: { linkId: string };
};

export const legacyPublishedTimelineBeforeLoad = ({
  params,
}: LegacyPublishedTimelineBeforeLoadArgs): never => {
  throw redirect({
    to: '/published/v1/roadmap/$linkId',
    params,
    search: true,
    replace: true,
  });
};

export const Route = createFileRoute('/(unauthenticated)/published/v1/timeline/$linkId')({
  beforeLoad: legacyPublishedTimelineBeforeLoad,
});
